import { Typography } from "antd";
import { Facebook, Linkedin, Twitter } from "lucide-react";
import { useLanguage } from "../../../context/LanguageContext";
import content from "../../../utils/content";

const { Text } = Typography;

export const Footer = () => {
  const { language } = useLanguage();
  const t = content[language].footer;

  return (
    <footer className="border-t">
      <div className="container px-4 md:px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* 1. Legal Items */}
          <div className="flex items-center gap-4">
            {t.legalItems.map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="text-sm text-gray-500 hover:text-gray-900"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* 2. Copyright */}
          <Text className="text-sm text-gray-500">
            © 2024 By Reebaq. All Rights Reserved.
          </Text>
          {/* 4. Payment Providers */}
          <div className="flex justify-center md:justify-end items-center gap-2">
            <img src="/payments/visa.svg" alt="Visa" className="h-3" />
            <img
              src="/payments/mastercard.svg"
              alt="Mastercard"
              className="h-4"
            />
            <img
              src="/payments/apple_pay.svg"
              alt="Apple Pay"
              className="h-4"
            />
            <img
              src="/payments/google_pay.svg"
              alt="Google Pay"
              className="h-4"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};
